import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import Bearing from "./components/Bearing";
import RunView from "./components/RunView";
import Dashboard from "./components/Dashboard";
import Counselors from "./components/Counselors";
import AuthCallback from "./components/AuthCallback";
import { AuthProvider } from "./lib/AuthContext";

function AppRouter() {
  const location = useLocation();
  // Handle OAuth callback synchronously before other routes render (prevents race conditions)
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Bearing />} />
      <Route path="/r/:shareId" element={<RunView />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/counselors" element={<Counselors />} />
      <Route path="*" element={<Bearing />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
